import Alert from '@mui/material/Alert';

import { COLORS } from '~/styles/colors';

type RedWhiteAlertProps = {
  text: string;
  isOpen: boolean;
  cameFromPopup?: boolean;
};

export const RedWhiteAlert = ({ text, isOpen, cameFromPopup = false }: RedWhiteAlertProps) => {
  if (!isOpen) return null;

  return (
    <Alert
      sx={{
        color: COLORS.disableGrayColor,
        position: 'absolute',
        top: '5%',
        background: cameFromPopup ? COLORS.white : undefined,
      }}
      variant="outlined"
      severity="error"
    >
      {text}
    </Alert>
  );
};
